<template>
  
  <div class="q-pa-md">
 <!--   <h6>{{this.formData}}</h6>    -->

    <q-table
      title="Competitors"
      :rows="rows"
      :columns="columns"
      row-key="name"
    />
    <div class="q-pa-md q-gutter-sm">
    
    <q-btn 
    color="primary" 
    label="Add"
    @click="fun" 
    />
    
  </div>
  <div class="q-pa-md" style="max-width: 400px">

    <q-form
      v-if="show"
      @submit="onSubmit"
      @reset="onReset"
      class="q-gutter-md"
    >
      <q-input
        filled
        type="number"
        v-model="formData.id"
        label="Company Id"
        lazy-rules
        :rules="[
          val => val !== null && val !== '' || 'Please type company id',
          val => val > 0 && val < 5000 || 'Please type a real age'
        ]"
      />

      <q-input
        filled
        v-model="formData.name"
        label="Company Name"
        lazy-rules
        :rules="[ val => val && val.length > 0 || 'Please type something']"
      />
      <q-input
        filled
        v-model="formData.productlink"
        label="Link to product"
        lazy-rules
        :rules="[ val => val && val.length > 0 || 'Please type something']"
      />

      <div>
        <q-btn label="Submit" type="submit" color="primary"/>
        <q-btn label="Reset" type="reset" color="primary" flat class="q-ml-sm" />
      </div>
    </q-form>

  </div>
  
  </div>
  
</template>

<script>
import axios from 'axios';

const columns = [
  {
    name: 'name',
    required: true,
    label: 'Company ID',
    align: 'left',
    field: row => row.name,
    format: val => `${val}`,
    sortable: true
  },
  { name: 'company_name', align: 'center', label: 'Company Name', field: 'company_name', sortable: true },
  { name: 'product_link', label: 'Product Link', field: 'product_link', sortable: true },
 // { name: 'carbs', label: 'Carbs (g)', field: 'carbs' },
 // { name: 'protein', label: 'Protein (g)', field: 'protein' },
 // { name: 'sodium', label: 'Sodium (mg)', field: 'sodium' },
 // { name: 'calcium', label: 'Calcium (%)', field: 'calcium', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) },
 // { name: 'iron', label: 'Iron (%)', field: 'iron', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) }
]


const rows = [
  {
    name: 'Frozen Yogurt',
    calories: 159,
    fat: 6.0,
    carbs: 24,
    protein: 4.0,
    sodium: 87,
    calcium: '14%',
    iron: '1%'
  },
  {
    name: 'Ice cream sandwich',
    calories: 237,
    fat: 9.0,
    carbs: 37,
    protein: 4.3,
    sodium: 129,
    calcium: '8%',
    iron: '1%'
  },
  {
    name: 'Eclair',
    calories: 262,
    fat: 16.0,
    carbs: 23,
    protein: 6.0,
    sodium: 337,
    calcium: '6%',
    iron: '7%'
  },
  {
    name: 'Cupcake',
    calories: 305,
    fat: 3.7,
    carbs: 67,
    protein: 4.3,
    sodium: 413,
    calcium: '3%',
    iron: '8%'
  },
  {
    name: 'Gingerbread',
    calories: 356,
    fat: 16.0,
    carbs: 49,
    protein: 3.9,
    sodium: 327,
    calcium: '7%',
    iron: '16%'
  },
  {
    name: 'Jelly bean',
    calories: 375,
    fat: 0.0,
    carbs: 94,
    protein: 0.0,
    sodium: 50,
    calcium: '0%',
    iron: '0%'
  },
  {
    name: 'Lollipop',
    calories: 392,
    fat: 0.2,
    carbs: 98,
    protein: 0,
    sodium: 38,
    calcium: '0%',
    iron: '2%'
  },
  {
    name: 'Honeycomb',
    calories: 408,
    fat: 3.2,
    carbs: 87,
    protein: 6.5,
    sodium: 562,
    calcium: '0%',
    iron: '45%'
  },
  {
    name: 'Donut',
    calories: 452,
    fat: 25.0,
    carbs: 51,
    protein: 4.9,
    sodium: 326,
    calcium: '2%',
    iron: '22%'
  },
  {
    name: 'KitKat',
    calories: 518,
    fat: 26.0,
    carbs: 65,
    protein: 7,
    sodium: 54,
    calcium: '12%',
    iron: '6%'
  }
]

 
      

export default {
  
  
  created(){

  },
  
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      show:false,
      formData:{
        id:"",
        name:"",
        productlink:'',
      },
      list:[],
      columns,
      rows,
    };
  },
  async mounted()
  {
      let result=await axios.get("http://localhost:3000/competitors");
      console.warn(result);
  },
  methods:{
    fun()
    {
      this.show=true;
      
      
    },
    async onSubmit()
    {
      console.warn("Hello from submit");
      await axios.post("http://localhost:3000/competitors",{
        company_id:this.formData.id,
        company_name:this.formData.name,
        product_link:this.formData.productlink,
      });
    //  console.warn(this.formData),
     //   alert("Saved succesfully",this.formData.id,this.formData.name);
        this.show=false;
    },
    onReset()
    {
      
      alert("Hello from reset");
        this.formData.id=null;
        this.formData.name=null;
        this.formData.productlink=null;

    }
  }
  
}
</script>

<style lang="stylus" scoped>

</style>



